import { getMemberListApi } from "@/api/pm/memberApi";
import { getTaskDataApi, getAllProjectCardTaskApi } from "@/api/pm/taskApi";
import { getProjectDetailApi } from "@/api/pm/projectApi";
import Vue from "vue";
const middleStroe = {
  state: {
    TeamMember: [],
    tmpProjectid: null,
    proDetail: {},
    taskList: [],
    commandMpa: {
      1: "",
      2: "priority",
      3: "principal",
      4: "status"
    },
    activeCommand: 2,
    ganttList: []
  },
  mutations: {
    SET_TEAM: (state, val) => {
      state.TeamMember = val;
    },
    SET_PROJECTID: (state, val) => {
      state.tmpProjectid = val;
    },
    SET_PRODETAIL: (state, val) => {
      state.proDetail = val;
    },
    SET_TASKLIST: (state, val) => {
      Vue.set(state, "taskList", val);
    },
    SET_COMMAND: (state, val) => {
      state.activeCommand = val;
    },
    SET_GANTTLIST: (state, val) => {
      Vue.set(state, "ganttList", val);
    }
  },

  actions: {
    async setTeamMember({ commit, state }, data) {
      commit("SET_PROJECTID", data.projectid);
      getProjectDetailApi({ projectid: state.tmpProjectid }).then(res => {
        if (!res.errno) commit("SET_PRODETAIL", res.data);
      });

      let res = await getMemberListApi({ projectid: state.tmpProjectid });
      if (!res.errno) {
        commit("SET_TEAM", res.data.list);
      }
      return res;
    },
    clearTeam({ commit, state }) {
      commit("SET_PROJECTID", null);
      commit("SET_PRODETAIL", {});
      commit("SET_TEAM", []);
      commit("SET_TASKLIST", []);
    },

    async getAllProjectCardTask({ commit, state }) {
      let res;
      let params = {
        projectid: state.tmpProjectid
      };
      let type = localStorage.getItem("__PROJECT_TASK_VIEW__") || "list";
      if (type == "board") {
        params["type"] = state.commandMpa[state.activeCommand];
        res = await getAllProjectCardTaskApi(params);
      } else {
        res = await getTaskDataApi(params);
      }
      commit("SET_TASKLIST", res.data.list);
      return res;
    },

    async setTaskdata({ commit, state }, data) {
      commit("SET_TASKLIST", data);
    },

    setCommand({ commit, state }, data) {
      commit("SET_COMMAND", data);
    },

    //gattlist写入
    setGanttList({ commit, state }, data) {
      commit("SET_GANTTLIST", data);
    }
  }
};

export default middleStroe;
